import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Logo } from "@/components/Logo";
import { CONTACT } from "@/i18n/translations";
import { useHome } from "@/i18n/home";
import { MapPin, Phone, MessageCircle } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  const f = useHome().footer;
  return (
    <footer className="relative overflow-hidden bg-[#F4F8FB] border-t border-[#E5E7EB]" data-testid="footer">
      <div className="h-1 w-full" style={{ background: "linear-gradient(90deg, #00C3FF 0%, #FF7A00 100%)" }} />
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-14">
        <div className="grid gap-10 lg:grid-cols-3">
          {/* brand + slogan */}
          <div>
            <Logo />
            <p className="mt-5 font-display text-lg font-semibold text-[#090A0C]">{t.footer.tagline}</p>
            <p className="mt-2 max-w-xs text-sm text-[#4B5563]">{f.desc}</p>
          </div>

          {/* contact */}
          <div>
            <p className="mb-4 text-xs uppercase tracking-widest font-bold text-[#0B87B0]">{f.contact}</p>
            <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 font-semibold text-[#090A0C] transition-colors hover:text-[#0B87B0]">
              <Phone size={16} color="var(--pt-blue)" /> {CONTACT.phone}
            </a>
            <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold text-white transition-transform hover:scale-[1.03]" style={{ background: "var(--pt-orange)" }}>
              <MessageCircle size={15} /> WhatsApp
            </a>
            <p className="mt-4 flex items-start gap-1.5 text-sm text-[#4B5563]" data-testid="footer-address">
              <MapPin size={15} className="mt-0.5 shrink-0" color="var(--pt-blue)" />
              Str. Tor 83 · 39030 St. Martin in Thurn (BZ) · {useHome().locations.country}
            </p>
          </div>

          {/* certification */}
          <div className="lg:justify-self-end">
            <p className="mb-4 text-xs uppercase tracking-widest font-bold text-[#0B87B0]">{f.certified}</p>
            <div className="inline-flex items-center gap-3 rounded-2xl border border-[#CBDDE9] bg-white p-4 shadow-[0_8px_24px_rgba(11,80,110,0.08)]" data-testid="footer-uwa">
              <img src="/unifi-uwa.png" alt="UniFi Wireless Administrator" className="h-12 w-auto object-contain" />
              <span className="text-sm font-semibold leading-tight text-[#090A0C]">UniFi<br />Wireless Administrator</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#DDE9F0] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#4B5563]">
          <span>© {new Date().getFullYear()} PowerTech des Zingerle Otto. {t.footer.rights}</span>
          <div className="flex items-center gap-5">
            <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-[#090A0C] transition-colors">{t.footer.impressum}</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-[#090A0C] transition-colors">{t.footer.datenschutz}</Link>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#090A0C] transition-colors">{t.footer.admin}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
